import { isRouteErrorResponse, useRouteError } from 'react-router';
import { ButtonLink, EmptyState } from '@/design-system';
import { ns, useT } from '@/i18n';

/** Last-resort error screen (a page crashed or its code failed to load). */
export function RouteError() {
  const error = useRouteError();
  const t = useT(ns.shell);
  const tc = useT(ns.common);
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : '';
  if (import.meta.env.DEV && message) console.error(error);
  return (
    <div className="l-wrap" style={{ padding: '120px 0' }}>
      <EmptyState
        icon="alert"
        look="card"
        title={t('error.title')}
        actions={
          <>
            <ButtonLink to="/" reloadDocument>
              {tc('backHome')}
            </ButtonLink>
          </>
        }
      >
        {t('error.text')}
      </EmptyState>
    </div>
  );
}
